import { createTheme } from "@material-ui/core/styles";

export default createTheme({
  overrides: {
    MuiFormLabel: {
      root: {
        "&.MuiInputLabel-shrink": {
          color: "#757575",
        },
      },
    },
    PrivateNotchedOutline: {
      root: {
        transition: "border 300ms ease-in-out",
      },
    },
    MuiOutlinedInput: {
      root: {
        transition: "border-color 1s ease-in-out",
        "&:hover $notchedOutline": {
          transition: "border 150ms ease-in-out",
          border: "1px solid #dd8a5f !important",
        },
        "&$focused $notchedOutline": {
          transition: "border 100ms ease-in-out",
          border: "2px solid #dd8a5f !important",
        },
        "&$active $notchedOutline": {
          transition: "border 150ms ease-in-out",
          border: "1px solid #dd8a5f !important",
        },
      },
    },
  },
});
